






































































































































































































































import Vue from 'vue';
import moment from 'moment';
import {
  CreateTrace,
  ReservationEntity,
  ScanEntity,
  CreateTraceAPIReturn,
  CurrentCheckIn,
  LocationEntity,
  GetReservationOptions,
} from '../../../types';
import { apiPostRequest } from '../helpers';
import * as TimeFormat from 'hh-mm-ss';

const apiBaseURL = process.env.VUE_APP_API_URL || '';

export default Vue.extend({
  name: 'location-check-in',
  props: {
    reservationQRCode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      timeRemaining: null as string | null,
      timeRemainingInterval: null as any,
      noStreamApiSupport: false,
    };
  },
  async created() {
    (this as any).startLoading();

    (this as any).updateQueryParameters();

    this.$store.commit('appData/REMOVE_EXISTING_DATA');

    const options: GetReservationOptions = {
      qrCode: this.reservationQRCode,
      customerId: (this as any).customerId,
    };

    await this.$store.dispatch('appData/GET_RESERVATION', options);

    (this as any).stopLoading();
  },
  mounted() {
    this.timeRemainingInterval = setInterval(() => {
      const now = +new Date();
      const endTime = (this as any).currentCheckInAutoCheckOutTimestamp;

      if (endTime !== null && endTime < now) {
        this.goToReservationDetails();
      }

      if (endTime !== null && moment(endTime).isValid()) {
        const secondsDifference = moment(endTime).diff(moment(now), 'seconds');
        const msDuration = moment.duration(secondsDifference, 'seconds').asMilliseconds();

        this.timeRemaining = TimeFormat.fromMs(msDuration);
      }
    }, 1000);
  },
  methods: {
    onDecode(qrCode: string): void {
      if (qrCode.length > 0) {
        this.checkIn(qrCode);
      }
    },
    logErrors(promise: any): void {
      promise.catch(console.error);
    },
    async onInit(promise: any) {
      try {
        await promise;
      } catch (error) {
        console.log('error', error.name);
        if (
          [
            'NotFoundError',
            'StreamApiNotSupportedError',
            'NotAllowedError',
            'NotSupportedError',
            'NotReadableError',
            'OverconstrainedError',
            'InsecureContextError',
          ].includes(error.name)
        ) {
          this.noStreamApiSupport = true;
        }
      }
    },
    async checkIn(qrCode: string): Promise<void> {
      (this as any).showLoader();

      const reservation: ReservationEntity = (this as any).reservation;

      const postBody: CreateTrace = {
        action: 1,
        reservationId: reservation.id,
        externalUserId: reservation.externalUserId || '',
      };

      const apiReturnRaw: any = await apiPostRequest({
        apiKey: reservation.apiKeyUsed,
        apiURL: `${apiBaseURL}customer/${reservation.customerId}/trace/${qrCode}`,
        postBody,
      });

      const apiReturn: CreateTraceAPIReturn = apiReturnRaw ? (apiReturnRaw.hasOwnProperty('success') ? apiReturnRaw : apiReturnRaw.data) : null;

      if (!apiReturn || !apiReturn.success) {
        (this as any).hideLoader();

        (this as any).$Simplert.open({
          title: this.$t('text.location_check_in_error'),
          message: this.$t('text.location_check_in_error_message'),
          type: 'warning',
          customCloseBtnText: this.$t('text.try_again'),
          customCloseBtnClass: 'btn primary-button',
          onClose: null,
        });
      } else {
        const scan = apiReturn.data!;

        const checkInLocation = reservation.location || reservation.locations.find((locationInner) => locationInner.id === scan.locationId);

        if (checkInLocation) {
          const autoCheckOutTime = moment(scan.scanned).add(checkInLocation.autoExitMinutes, 'minutes');

          const currentCheckIn: CurrentCheckIn = {
            scan,
            location: checkInLocation,
            reservation: (this as any).reservation,
            autoCheckOutTimestamp: autoCheckOutTime.valueOf(),
            externalUserId: scan.externalUserId,
          };

          this.$store.commit('appData/SET_CURRENT_CHECK_IN', currentCheckIn);
        }

        (this as any).hideLoader();
      }
    },
    async checkOut(): Promise<void> {
      (this as any).showLoader();

      const reservation: ReservationEntity = (this as any).reservation;
      const location: LocationEntity = (this as any).currentCheckInLocation;

      const postBody: CreateTrace = {
        action: 2,
        reservationId: reservation.id,
        externalUserId: reservation.externalUserId || '',
      };

      const apiReturnRaw: any = await apiPostRequest({
        apiKey: reservation.apiKeyUsed,
        apiURL: `${apiBaseURL}customer/${reservation.customerId}/trace/${location.apiKeyCreateReservation}`,
        postBody,
      });

      const apiReturn: CreateTraceAPIReturn = apiReturnRaw.hasOwnProperty('success') ? apiReturnRaw : apiReturnRaw.data;

      (this as any).hideLoader();

      if (!apiReturn.success) {
        (this as any).$Simplert.open({
          title: this.$t('text.location_check_out_error'),
          message: this.$t('text.location_check_out_error_message'),
          type: 'warning',
          customCloseBtnText: this.$t('text.try_again'),
          customCloseBtnClass: 'btn primary-button',
          onClose: this.checkOut,
        });
      } else {
        this.goToReservationDetails();
      }
    },
    goToReservationDetails(): void {
      const currentCheckIn: CurrentCheckIn = {
        scan: null,
        location: null,
        reservation: null,
        autoCheckOutTimestamp: null,
        externalUserId: null,
      };

      this.$store.commit('appData/SET_CURRENT_CHECK_IN', currentCheckIn);

      this.$router.push({
        name: 'reservation-details',
        params: {
          reservationQRCode: (this as any).reservationQRCode,
        },
        query: {
          customerId: (this as any).reservation.customerId,
        },
      });
    },
  },
  beforeDestroy() {
    clearInterval(this.timeRemainingInterval);
  },
  watch: {
    async reservation(newVal) {
      if (newVal) {
        const location: LocationEntity = newVal.location;
        const locations: LocationEntity[] = newVal.locations;

        if (location || locations) {
          const translations = location
            ? location.translations
            : locations && locations.find((location) => location.translations)
            ? locations.find((location) => location.translations)!.translations
            : null;

          const visualSettings = location
            ? location.visualSettings
            : locations && locations.find((location) => location.visualSettings)
            ? locations.find((location) => location.visualSettings)!.visualSettings
            : null;

          (this as any).setTranslations(translations, newVal.lang);

          (this as any).setVisualSettings(visualSettings);
        }

        if (newVal.scans && newVal.scans.length > 0) {
          const checkInScans = newVal.scans.filter((scan: ScanEntity) => scan.type === 3);
          const checkOutScans = newVal.scans.filter((scan: ScanEntity) => scan.type === 4);

          if (checkInScans.length > checkOutScans.length) {
            const latestCheckInScan = checkInScans.reduce((prev: ScanEntity, current: ScanEntity) => (prev.id > current.id ? prev : current));

            const checkInLocation = location || locations.find((locationInner) => locationInner.id === latestCheckInScan.locationId);

            if (checkInLocation) {
              const autoCheckOutTime = moment(latestCheckInScan.scanned).add(checkInLocation.autoExitMinutes, 'minutes');

              if (moment().isBefore(autoCheckOutTime)) {
                const currentCheckIn: CurrentCheckIn = {
                  scan: latestCheckInScan,
                  location: checkInLocation,
                  reservation: newVal,
                  autoCheckOutTimestamp: autoCheckOutTime.valueOf(),
                  externalUserId: newVal.externalUserId,
                };

                this.$store.commit('appData/SET_CURRENT_CHECK_IN', currentCheckIn);
              }
            }
          }
        }
      }
    },
  },
});
